import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { Injectable } from '@angular/core';
import { PartySearchApiService } from '../../features/party-search/party-search-api.service';
import { SnackbarService } from '../services/snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class PartySearchResultGuard implements CanActivate {
  constructor(
    private service: PartySearchApiService,
    private snackbarService: SnackbarService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const queryParams = route.queryParams;
    const targetProps = ['court', 'fingerprint', 'report'];

    const propMessageMap = new Map([
      ['court', `Case No. ${queryParams['court']} Not found.`],
      ['fingerprint', `Fingerprint#  ${queryParams['fingerprint']} Not found.`],
      ['report', `Report # ${queryParams['report']} Not found.`],
    ]);

    const nonEmptyParams = Object.entries(queryParams).filter(([key]) => key !== 'isFromHome');;

    if (nonEmptyParams.length === 1 && targetProps.indexOf(nonEmptyParams[0][0]) !== -1) {
      return this.service
        .getPersonSearchCases({
          reportNumber: queryParams['report'] ?? '',
          courtNumber: queryParams['court'] ?? '',
          ocn: queryParams['fingerprint'] ?? '',
        })
        .pipe(
          map(data => {
            if (data.length > 1) {
              this.router.navigate(['/multifile-search-result'], { queryParams: queryParams });
              return true;
            } else if (data.length === 1) {
              const casePage = data[0].isCivilCase == 'N'  ? 'case-info' : 'civil-case';
              const caseId = encodeURIComponent(data[0].caseId);
              return this.router.parseUrl(`/${casePage}/${caseId}`);
            } else {
              this.showErrorModal(propMessageMap.get(nonEmptyParams[0][0])!);
              return false;
            }
          })
        );
    }

    return true;
  }

  private showErrorModal(message: string): void {
    this.snackbarService.showError(message);
  }
}
